import { useEffect, useState } from "react"
import AnalyticsPage from "./AnalyticsPage"
// import BetaAccessPage from "./BetaAccessPage"
// import ManageAccessCodesPage from "./ManageAccessCodesPage"
import Menu from "../../components/menu/Menu"
const MyraInsightsPage = () => {
  return (
    <div className="bg-white rounded-xl p-12 shadow-sm border border-slate-200 text-center">
      <div className="text-6xl mb-4">🤖</div>
      <h2 className="text-xl font-semibold text-slate-800 mb-2">Myra Insights Coming Soon</h2>
      <p className="text-slate-500 max-w-md mx-auto">
        Once the chat_history table is populated, this tab will show detailed Myra engagement analytics,
        intent analysis, and conversation insights.
      </p>
      <div className="mt-8 p-6 bg-slate-50 rounded-lg max-w-lg mx-auto text-left">
        <h3 className="font-medium text-slate-700 mb-3">Planned Features:</h3>
        <ul className="space-y-2 text-sm text-slate-600">
          <li className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-purple-400"></span>
            Engagement by touchpoint (landing, post-plan)
          </li>
          <li className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-purple-400"></span>
            Top user intents and questions asked
          </li>
          <li className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-purple-400"></span>
            Conversion rate comparison (with vs. without Myra)
          </li>
          <li className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-purple-400"></span>
            Chat volume trends over time
          </li>
          <li className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-purple-400"></span>
            Sample conversation viewer
          </li>
        </ul>
      </div>
    </div>
  )
}


const AnalyticsPageTabs = (props) => {
  const [activeTab, setActiveTab] = useState("analytics")
   const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    props.actSidebar(true);
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    }
    // eslint-disable-next-line
  }, []);
  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1); // Increment to force re-render
  }

  // const tabs = [
  //   { id: "analytics", label: "Analytics", component: AnalyticsPage },
  //   { id: "beta-log", label: "Beta Access Log", component: BetaAccessPage },
  //   { id: "manage-codes", label: "Manage Access Codes", component: ManageAccessCodesPage },
  // ]
  const tabs = [
    { id: "analytics", label: "Overview & Journey", component: AnalyticsPage },
    { id: "myra", label: "Myra Insights", component: MyraInsightsPage, badge: "Coming Soon" },
  ]

  const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component || AnalyticsPage

  return (
    <div className="max-h-screen overflow-y-auto w-full ">
      <Menu title={"Analytics"} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pt-0 font-['Inter',sans-serif]">
                <div className="flex justify-end items-center mb-4">
          <button
            onClick={handleRefresh}
            className="flex items-center gap-2 px-4 py-2 bg-teal-50 text-teal-700 hover:bg-teal-100 border border-teal-200 rounded-lg font-medium text-sm transition-colors"
            title="Refresh dashboard data"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-4 w-4" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" 
              />
            </svg>
            Refresh Data
          </button>
        </div>

        {/* Main Content */}
        <main className="py-8">
          {/* Tabs */}
          <div className="border-b border-slate-200">
            <nav
              className="-mb-px flex overflow-x-auto no-scrollbar max-w-[80vw]"
              aria-label="Tabs"
            >
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex-shrink-0 whitespace-nowrap py-3 px-4 border-b-2 font-medium text-sm transition-colors ${activeTab === tab.id
                      ? "border-teal-600 bg-teal-50 text-teal-700"
                      : "border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
                    }`}
                >
                  {tab.label}
                  {tab.badge && (
                    <span className="ml-2 px-1.5 py-0.5 text-xs font-semibold rounded-full bg-purple-100 text-purple-700">
                      {tab.badge}
                    </span>
                  )}
                </button>
              ))}
            </nav>
          </div>


          {/* Tab Content */}
          <div className="mt-8">
            <ActiveComponent {...props} refreshKey={refreshKey} />
          </div>
        </main>
      </div>
    </div>
  )
}

export default AnalyticsPageTabs